var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colored-progress-bar mt-2",style:(_vm.backgroundStyle)},[_c('div',{staticClass:"colored-progress-bar_arrow",style:(_vm.arrowStyle)},[_c('i',{staticClass:"fas fa-play fa-rotate-90"})])])}
var staticRenderFns = []

export { render, staticRenderFns }